/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates some simple date formats to be used.
 */
export var DayOfWeek = /*@__PURE__*/ (function (DayOfWeek) {
    /**
     * First Day of Week is Sunday
     */
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
    /**
     * First Day of Week is Monday
     */
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    /**
     * First Day of Week is Tuesday
     */
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    /**
     * First Day of Week is Wednesday
     */
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    /**
     * First Day of Week is Thursday
     */
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    /**
     * First Day of Week is Friday
     */
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    /**
     * First Day of Week is Saturday
     */
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
    return DayOfWeek;
})({});
/**
 * @hidden
 */
export var DayOfWeek_$type = /*@__PURE__*/ markEnum('DayOfWeek', 'Sunday,0|Monday,1|Tuesday,2|Wednesday,3|Thursday,4|Friday,5|Saturday,6');
//# sourceMappingURL=DayOfWeek.js.map
